import { BadgeCheck, ArrowRight } from "lucide-react";
import { ASSETS, scrollToId } from "../constants";
import { useLanguage } from "../i18n/LanguageContext";
import { Reveal } from "./Reveal";

const NoDeposit = () => {
  const { t } = useLanguage();

  const explore = () => {
    window.dispatchEvent(new CustomEvent("aa:no-deposit-filter"));
    scrollToId("fleet");
  };

  return (
    <section id="no-deposit" data-testid="no-deposit-section" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img src={ASSETS.heroBanner} alt="" aria-hidden="true" loading="lazy" className="h-full w-full object-cover object-center opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#08080A] via-[#08080A]/70 to-[#08080A]" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:px-8 lg:py-32">
        <div className="grid items-center gap-10 lg:grid-cols-[1.4fr_1fr]">
          <Reveal>
            <p className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.3em] text-gold">
              <BadgeCheck className="h-4 w-4" aria-hidden="true" />
              {t("nodeposit.eyebrow")}
            </p>
            <h2 className="mt-5 font-display text-4xl font-bold uppercase leading-tight text-white sm:text-5xl lg:text-6xl">
              <span className="text-gold-gradient">{t("nodeposit.title")}</span>
            </h2>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-slate-300">{t("nodeposit.text")}</p>
            <button
              type="button"
              data-testid="no-deposit-explore-button"
              onClick={explore}
              className="group mt-9 inline-flex items-center gap-3 rounded-full bg-gold px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] text-[#08080A] transition-all duration-300 hover:bg-gold-light hover:shadow-[0_0_40px_rgba(212,175,55,0.4)]"
            >
              {t("nodeposit.cta")}
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1 rtl:rotate-180 rtl:group-hover:-translate-x-1" aria-hidden="true" />
            </button>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="gold-border-glow rounded-3xl border border-gold/20 bg-[#0c0c10]/80 p-8 backdrop-blur-md">
              <span className="font-display text-7xl font-bold text-gold-gradient">0%</span>
              <p className="mt-2 font-display text-2xl font-semibold text-white">{t("fleet.noDeposit")}</p>
              <p className="mt-4 text-sm leading-relaxed text-slate-400">{t("nodeposit.note")}</p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default NoDeposit;
